import request from '@/utils/request'
import qs from 'qs'

const getUserById = (id) => {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/${id}`,
    method: 'get'
  })
}

const getUsersPageList = (query) => {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/getUsersPageList`,
    method: 'get',
    params: query
  })
}

const getAdminByCompanyId = (companyId) => {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/getAdminByCompanyId`,
    method: 'get',
    params: { companyId }
  })
}

const getStudentTotalByClassesIds = (classesIds) => {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/getStudentTotalByClassesIds`,
    method: 'get',
    params: { classesIds },
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

const getTeacherAll = () => {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/getTeacherAll`,
    method: 'get'
  })
}

const getUsersLike = (query) => {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/getUsersLike`,
    method: 'get',
    params: query
  })
}

function createUser(data) {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/create`,
    method: 'post',
    data
  })
}

const updateUser = (id, data) => {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/${id}`,
    method: 'put',
    data
  })
}

const updateCompanyAdmin = (companyId, admins) => {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/updCompanyAdmin`,
    method: 'put',
    params: { companyId },
    data: admins
  })
}

const getTeacherAllCache = () => {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/getTeacherAllCache`,
    method: 'get'
  })
}

const getRoleIdsByUserId = (userId) => {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/getRoleIdsByUserId`,
    method: 'get',
    params: { userId }
  })
}

const getUserInfoByUserId = (userId) => {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/getUserInfo`,
    method: 'get',
    params: { userId }
  })
}

const updateUserStateByIds = (ids, state) => {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/updateState`,
    method: 'put',
    params: { state },
    data: ids
  })
}

const resetPassword = (ids) => {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/resetPassword`,
    method: 'put',
    data: ids
  })
}

const unlock = (ids) => {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/unlock`,
    method: 'put',
    data: ids
  })
}

const getCurrentUser = () => {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/getCurrentUser`,
    method: 'get'
  })
}

const changePassword = (data) => {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/changePassword`,
    method: 'put',
    data
  })
}

const uploadAvatar = (userId, avatar) => {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/uploadAvatar`,
    method: 'put',
    params: { userId },
    data: `"${avatar}"`,
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

const checkUserName = (userName) => {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/CheckUserName`,
    method: 'get',
    params: { userName }
  })
}

const checkPhoneNumber = (phoneNumber) => {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/CheckPhoneNumber`,
    method: 'get',
    params: { phoneNumber }
  })
}

const checkEmail = (email) => {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/CheckEmail`,
    method: 'get',
    params: { email }
  })
}

function batchCreateUser(data) {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/batchCreate`,
    method: 'post',
    data
  })
}

const setCurrentClassesId = (classesId) => {
  return request({
    url: `${process.env.VUE_APP_USER_API}/user/setCurrentClassesId`,
    method: 'put',
    params: { classesId }
  })
}

export default {
  createUser,
  updateUser,
  updateCompanyAdmin,
  getUsersPageList,
  getAdminByCompanyId,
  getStudentTotalByClassesIds,
  getTeacherAll,
  getUsersLike,
  getUserById,
  getTeacherAllCache,
  getRoleIdsByUserId,
  getUserInfoByUserId,
  updateUserStateByIds,
  resetPassword,
  unlock,
  getCurrentUser,
  changePassword,
  uploadAvatar,
  checkUserName,
  checkPhoneNumber,
  checkEmail,
  batchCreateUser,
  setCurrentClassesId
}
